import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getActivityInitialMonth = createSelector(
  (state: State) => state.activity.currentMonth,
  (state: State) => state.activity.currentYear,

  (currentMonth, currentYear): Date => {
    return new Date(+currentYear, currentMonth.num);
  }
);

export default getActivityInitialMonth;
